import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { CompanyProfileService, CompanyProfileOptions, BusinessSector, EmployeeCount, JobTitle } from 'app/services/http/company-profile.service';

@Component({
    selector: 'app-company-profile-dialog',
    templateUrl: './company-profile-dialog.component.html',
    styleUrls: ['./company-profile-dialog.component.scss']
})
export class CompanyProfileDialogComponent implements OnInit {

    form: FormGroup;
    isLoading = false;
    isSaving = false;

    businessSectors: BusinessSector[] = [];
    employeeCounts: EmployeeCount[] = [];
    jobTitles: JobTitle[] = [];

    constructor(
        private formBuilder: FormBuilder,
        private companyProfileService: CompanyProfileService,
        private snackBar: MatSnackBar,
        public matDialogRef: MatDialogRef<CompanyProfileDialogComponent>
    ) {
        this.matDialogRef.addPanelClass('no-padding-dialog-container');

        this.form = this.formBuilder.group({
            business_sector_code: ['', Validators.required],
            employee_count: ['', Validators.required],
            user_job_title: ['', Validators.required]
        });
    }

    ngOnInit(): void {
        this.loadOptions();
    }

    loadOptions(): void {
        this.isLoading = true;
        this.companyProfileService.getOptions().subscribe({
            next: (options: CompanyProfileOptions) => {
                this.businessSectors = options.business_sectors;
                this.employeeCounts = options.employee_counts;
                this.jobTitles = options.job_titles;
                this.isLoading = false;
            },
            error: (err) => {
                this.snackBar.open('Erro ao carregar opções', 'OK', { duration: 3000 });
                this.isLoading = false;
            }
        });
    }

    save(): void {
        if (this.form.invalid) {
            this.snackBar.open('Preencha todos os campos', 'OK', { duration: 3000 });
            return;
        }

        this.isSaving = true;
        this.companyProfileService.store(this.form.value).subscribe({
            next: (res) => {
                this.snackBar.open('Dados salvos com sucesso!', 'OK', { duration: 3000 });
                this.matDialogRef.close(true);
            },
            error: (err) => {
                this.snackBar.open('Erro ao salvar dados', 'OK', { duration: 3000 });
                this.isSaving = false;
            }
        });
    }

    skip(): void {
        this.matDialogRef.close(false);
    }
}
